import React from 'react';
import { Thermometer, Wind, Heart } from 'lucide-react';
import { motion } from 'framer-motion';
export function EmotionalSection() {
  const scenarios = [{
    icon: Thermometer,
    title: '2:00 am — Fiebre inesperada',
    description: 'Tocas su frente y está ardiendo. No sabes si es grave. Google te asusta más y la ansiedad crece mientras todos duermen.'
  }, {
    icon: Wind,
    title: 'Tos que no para',
    description: 'Lleva tres noches sin dormir bien. Tú tampoco. Quieres hacer algo para aliviarlo, pero no sabes qué remedio es seguro y efectivo.'
  }, {
    icon: Heart,
    title: 'Dolor de barriga',
    description: 'Llora y no puede explicarte bien qué siente. Te sientes impotente al verlo sufrir y solo quieres que se sienta mejor.'
  }];
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-27">
            ¿Te ha pasado esto?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-forest/70 max-w-2xl mx-auto" data-id="element-28">
            La maternidad tiene momentos difíciles, especialmente cuando la
            salud de nuestros pequeños se ve afectada.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-29">
          {scenarios.map((scenario, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1 + 0.2
        }} className="bg-cream rounded-2xl p-8 border border-sage/10 hover:shadow-lg hover:shadow-sage/10 transition-shadow duration-300" data-id="element-30">
              <div className="bg-white w-14 h-14 rounded-full flex items-center justify-center mb-6 shadow-sm text-terracotta" data-id="element-31">
                <scenario.icon className="h-7 w-7" data-id="element-32" />
              </div>
              <h3 className="text-xl font-bold text-forest mb-3" data-id="element-33">
                {scenario.title}
              </h3>
              <p className="text-forest/70 leading-relaxed" data-id="element-34">
                {scenario.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center mt-12" data-id="element-35">
          <p className="text-xl font-serif italic text-terracotta font-medium" data-id="element-36">
            No estás sola. Y no tienes que improvisar.
          </p>
        </motion.div>
      </div>
    </section>;
}